<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Helpful ADF Information</v-card-title>

        <v-card-text>

             <p>
                 <a href="http://adfxml.info/adf_spec.pdf" target="_blank">ADF Specification</a>
             </p>

             <p>
                 <a href="https://cm.dealer.reyrey.net/" target="_blank">Sanderson Test Account</a>
             </p>

             <m-code-block>sandersonlincoln@newsales.leads.cmdlr.com</m-code-block>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>